import config from "src/config";
import http from "../services/apiServices";
import { isCivilDefenseUser } from 'src/utils/helpers';

export const getATECasesApi = async (data: any) => {
  const api = isCivilDefenseUser() ? config.Case.RetrieveCDUCaseRequests : config.Case.RetrieveATECaseRequests
  var pathName = window.location.pathname;
  if (pathName && pathName.includes('breached')) {
    data.SLABreached = true;
    data.isBreached = true;
  }
  return await http.post(api, data);
};
export const sendRequestToOwnerApi = async () => {
  await http.get("https://jsonplaceholder.typicode.com/posts/1");
};

export const updateCaseStatusAPI = async (data: any) => {
  return await http.post(config.Case.updateStatus, data);
};

export const getStatusOptionsApi = async () => {
  return await http.get(config.Case.getCaseStatuses);
};

export const retrieveCaseStatusForEditCaseAPI = async () => {
  return await http.get(config.Case.retrieveCaseStatusForEditCase);
};